export enum AssayType {
  PRODUCT = 'Product',
}
